import type { Entity } from '../../entity/index'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'
import createLazyReadOnlyGridXY from '../createLazyReadOnlyGridXY'
import findMostEfficientPathToTileV2 from './findMostEfficientPathToTileV2'

export type LazyEfficientPathGrid_Result = ReturnType<typeof createLazyEfficientPathGridV2>

export default function createLazyEfficientPathGridV2(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
) {
  const lazyCostGrid = createLazyReadOnlyGridXY(
    gridWidth,
    gridHeight,
    function getEfficientPath(x: number, y: number) {
      return findMostEfficientPathToTileV2(grid, unit, gridWidth, gridHeight, x, y)
    }
  )
  return lazyCostGrid
}
